export enum StepperDirection {
  Left,
  Right,
}
